import Card16Podcast from "components/Card16Podcast/Card16Podcast";
import React, { FC } from "react";
import HeaderFilter4 from "./HeaderFilter4"

const SectionMagazine8 = ({
  posts,
  className = "",
}) => {
  const kitchens = posts.filter((post) => post.section_id == 10)
  return (
    <div className={`nc-SectionMagazine8 relative ${className}`}>
      <div className="mobile-header">
      <HeaderFilter4 heading="Kuchnia"></HeaderFilter4>
      </div>
      <button className="subcategory-btn" style={{backgroundColor:'red', fontSize:'20px', color:"white", marginTop:"10px", marginBottom:'10px', width:"52%", border:"none", padding:"3px 3px 3px 3px"}}>Kuchnia regionalna</button>
      <div style={{marginBottom:"2rem"}} className={`grid grid-cols-1 sm:grid-cols-4 gap-6 md:gap-8`}>
        {kitchens.map((kitchen) => {
          return <Card16Podcast
          key={kitchen.id}
          className="sm:col-span-3 lg:col-span-2"
          post={kitchen}
        /> 
        })}
        {/* <div className="flex flex-col space-y-6 md:space-y-8 sm:col-span-6 lg:col-span-2">
          {posts
            .filter((_, i) => i > 1 && i < 6)
            .map((p) => (
              <Card17Podcast key={p.id} post={p} />
            ))}
        </div> */}
      </div>
    </div>
  );
};

export default SectionMagazine8;
